import Vue from 'vue'
import Store from '../store/index'
import doc from '../assets/images/archives/doc.png'
import pdf from '../assets/images/archives/pdf.png'
import ppt from '../assets/images/archives/ppt.png'
import xls from '../assets/images/archives/xls.png'
import jpg from '../assets/images/archives/jpg.png'
import zip from '../assets/images/archives/zip.png'
import dwg from '../assets/images/archives/dwg.png'
import cad from '../assets/images/archives/cad.png'
import file from '../assets/images/archives/file.png'
import common from '../assets/images/archives/common.png'

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// new Date().Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// new Date().Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))); }
  return fmt;
}

const remixChinaDate = function (date) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  return y + '-' + m + '-' + d
}
const remixChinaDateTime = function (date) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let mins = date.getMinutes()
  mins = mins < 10 ? '0' + mins : mins
  let s = date.getSeconds()
  s = s < 10 ? '0' + s : s
  return y + '-' + m + '-' + d + ' ' + h + ':' + mins
}
const compareDate = function (startTime, endTime) {
  console.log(startTime)
  console.log(endTime)
  var oDate1 = new Date(startTime);
  var oDate2 = new Date(endTime);
  if (oDate1.getTime() > oDate2.getTime()) {
    return false;
  } else if (oDate1.getTime() < oDate2.getTime()) {
    return true;
  } else {
    return true;
  }
}
const unique = function (arr) {
  let map = new Map();
  console.log(map)
  // let arr1 = new Array();      // 数组用于返回结果
  let arr1 = []
  for (let i = 0, len = arr.length; i < len; i++) {
    if (map.has(arr[i])) { // 判断是否存在该key值
      map.set(arr[i], true);
    } else {
      map.set(arr[i], false);
      arr1.push(arr[i]);
    }
  }
  return arr1;
}
const resetListActions = function (list, approve) {
  list.forEach(item => {
    let flag = false;
    let history = '' // 历史记录放最后面
    for (let key in item.actions) {
      // 同意
      if (key === 'agree') {
        item.actions[key].name = '办理'
        flag = true;
      }
      // 驳回
      if (key === 'reject') {
        delete item.actions[key]
        // flag = true;
      }
      // 撤回上报
      if (key === 'revokeReport') {
        delete item.actions[key]
        // flag = true;
      }
      // 重新上报
      if (key === 'report') {
        // item.actions[key].name = '上报'
        delete item.actions[key]
        // flag = true;
      }
      // 历史记录
      if (key === 'getHistory') {
        item.actions[key].name = '历史记录'
        history = item.actions[key]
      }
      // 作废 有审批时没有作废
      if (key === 'cancel') {
        delete item.actions[key]
      }
    }
    if (history !== '') {
      delete item.actions.getHistory
      item.actions.getHistory = history
    }
    if(flag&&item.actions.show){

      // delete item.actions.show

    }
  })
}
// 对于列表的actions统一处理
const resetListActions2 = function(list, approve) {
  list.forEach(item => {
    let history = '' // 历史记录放最后面
    for (let key in item.actions) {
      // 同意
      if (key === 'agree') {
        item.actions[key].name = '审批'
      }
      // 驳回
      if (key === 'reject') {
        // item.actions[key].name = '驳回'
        delete item.actions[key]
      }
      // 撤回上报
      if (key === 'revokeReport') {
        delete item.actions[key]
      }
      // 重新上报
      if (key === 'report') {
        item.actions[key].name = '上报'
        // delete item.actions[key]
      }
      // 历史记录
      if (key === 'getHistory') {
        item.actions[key].name = '历史记录'
        history = item.actions[key]
      }
      // 作废 有审批时没有作废
      if (key === 'cancel') {
        delete item.actions[key]
      }
      // 作废 有审批时没有作废
      if (key === 'chsb') {
        delete item.actions[key]
      }
    }
    if (history !== '') {
      delete item.actions.getHistory
      item.actions.getHistory = history
    }
  })
}

// 获取日期
const getDateString = function (date) {
  date = date ? new Date(date) : new Date()

  let year = date.getFullYear() // 年 ,从 Date 对象以四位数字返回年份
  let month = date.getMonth() + 1 // 月 ,从 Date 对象返回月份 (0 ~ 11) ,date.getMonth()比实际月份少 1 个月
  let day = date.getDate() // 日 ,从 Date 对象返回一个月中的某一天 (1 ~ 31)

  let hours = date.getHours() // 小时 ,返回 Date 对象的小时 (0 ~ 23)
  let minutes = date.getMinutes() // 分钟 ,返回 Date 对象的分钟 (0 ~ 59)
  let seconds = date.getSeconds() // 秒 ,返回 Date 对象的秒数 (0 ~ 59)

  // 修改月份格式
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }

  // 修改日期格式
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }

  // 修改小时格式
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }

  // 修改分钟格式
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }

  // 修改秒格式
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }

  // 获取当前系统时间  格式(yyyy-mm-dd hh:mm:ss)
  let currentFormatDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  return currentFormatDate
}

const ObjectSize = function (obj) {
  var size = 0, key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
}
/* 定义页面返回跳转 */
const goBackNum = function (number, time) {
  setTimeout(() => {
    console.log(Vue)
    Vue.$router.go(number)
  }, time)
}
/* 定义跳转下一个页面的动画 */
const goNext = function (number, time) {
  Store.dispatch('index/update_transitionname', 'van-slide-right')
}
/* 定义跳转上一个页面的动画 */
const goBack = function (number, time) {
  Store.dispatch('index/update_transitionname', 'van-slide-left')
}

/**
 * 显示文件图标
 * @param value 文件名
 * @returns {string}
 * @param path    当前相对路径   ../../
 */

const filesTypeFilter = function(value, path) {
  let iconSrc = ''
  let type = ''
  if (value.split('.').length > 1) {
    type = value.split('.')[value.split('.').length - 1].toLowerCase()
    switch (type) {
      case 'doc':
        iconSrc = doc
        break
      case 'docx':
        iconSrc = doc
        break
      case 'pdf':
        iconSrc = pdf
        break
      case 'ppt':
        iconSrc = ppt
        break
      case 'xls':
        iconSrc = xls
        break
      case 'xlsx':
        iconSrc = xls
        break
      case 'jpg':
        iconSrc = jpg
        break
      case 'jpeg':
        iconSrc = jpg
        break
      case 'svg':
        iconSrc = jpg
        break
      case 'png':
        iconSrc = jpg
        break
      case 'zip':
        iconSrc = zip
        break
      case 'rar':
        iconSrc = zip
        break
      case 'dwg':
        iconSrc = dwg
        break
      case 'cad':
        iconSrc = cad
        break
      case undefined:
        iconSrc = file
        break
      default:
        iconSrc = common
        break
    }
    return iconSrc
  } else {
    return file
  }
}
const getFileType = function(fileName) {
  let type = ''
  if (fileName.split('.').length > 1) {
    type = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
  } else {
    type = 'file'
  }
  return type
}
const getSearchString = function(name) {
  var result = location.search.match(new RegExp('[\?\&]' + name + '=([^\&]+)', 'i'))
  if (result == null || result.length < 1) {
    return ''
  }
  return result[1]
}
const getQueryString = function(name) {
  var result = location.hash.match(new RegExp('[\?\&]' + name + '=([^\&]+)', 'i'))
  if (result == null || result.length < 1) {
    return ''
  }
  return result[1]
}
const remixArray = function (array) {
  array.forEach((item, index) => {
    item.name = item.label
  })
}
const flat = (arr, key = 'children') => {
  let newArr = [];
  let cycleArray = (arr) => {
    arr.map(item => {
      if (item) {
        newArr.push(item);
      }
      if (item[key] && item[key].length > 0) {
        cycleArray(item[key]);
      }
    });
  };
  cycleArray(arr);
  return newArr;
}


const deepClone = function (target) {
  // 定义一个变量
  let result
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = [] // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(this.deepClone(target[i]))
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {}
      for (let i in target) {
        result[i] = this.deepClone(target[i])
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target
  }
  // 返回最终结果
  return result
}



export default {
  resetListActions,
  resetListActions2,
  ObjectSize,
  goBack,
  goNext,
  goBackNum,
  filesTypeFilter,
  getFileType,
  getSearchString,
  getQueryString,
  remixArray,
  remixChinaDate,
  remixChinaDateTime,
  compareDate,
  flat,
  getDateString,
  unique,
  deepClone,

}



// WEBPACK FOOTER //
// ./src/assets/public.js